import {
  CreateOnboardingInfoDto,
  OnboardingInfoFe,
} from "@intelligems/ig-types";

export const getOrderVolumeValue = (orderCount: number): string => {
  if (orderCount < 500) {
    return "<500 orders";
  } else if (orderCount >= 500 && orderCount <= 2000) {
    return "500-2,000 orders";
  } else if (orderCount > 2000 && orderCount <= 5000) {
    return "2,000-5,000 orders";
  } else if (orderCount > 5000 && orderCount <= 20000) {
    return "5,000-20,000 orders";
  } else if (orderCount > 20000 && orderCount <= 100000) {
    return "20,000-100,000 orders";
  } else if (orderCount > 100000) {
    return "100,000+ orders";
  } else {
    return "I don't know";
  }
};

export const getOnboardingInfoPayload = (
  info: OnboardingInfoFe
): CreateOnboardingInfoDto => {
  return {
    userReportedOrderCount: info.userReportedOrderCount,
    teamDescription:
      info.teamDescription === "ig-empty" || !info.teamDescription
        ? "Not specified"
        : info.teamDescription,
    storeType: info.storeType,
    productionStoreUrl: info.productionStoreUrl,
    agencyPrimaryOperator:
      !info.agencyPrimaryOperator || info.agencyPrimaryOperator === "ig-empty"
        ? undefined
        : info.agencyPrimaryOperator,
    goals:
      info.goals.includes("Set a Custom Goal") && info.otherGoal
        ? info.otherGoal
        : info.goals.join(","),
    buyingIntention:
      info.buyingIntention === "Other"
        ? info.otherBuyingIntention
        : info.buyingIntention,
    sourceAttribution:
      info.sourceAttribution === "Other"
        ? info.otherSourceAttribution
        : info.sourceAttribution,
  };
};
export const booleanEval = (value: string | null | undefined) => {
  return !value || value === "ig-empty";
};
export const isContinueDisabled = (
  info: OnboardingInfoFe,
  currentStep: number
) => {
  const isOtherRoleNotDefined =
    info.companyRole === "Other" && booleanEval(info.otherRole);
  const agencyOperatorEval =
    info.companyRole === "Agency User" &&
    booleanEval(info.agencyPrimaryOperator);
  switch (currentStep) {
    case 0:
      if (
        !info.preferredName ||
        !info.preferredEmail ||
        booleanEval(info.companyRole) ||
        isOtherRoleNotDefined ||
        booleanEval(info.teamDescription) ||
        booleanEval(info.previousExperience) ||
        agencyOperatorEval
      ) {
        return {
          isDisabled: true,
          reason: `Please fill out your ${!info.preferredName ? "name" : !info.preferredEmail ? "email" : booleanEval(info.teamDescription) ? "team description" : booleanEval(info.previousExperience) ? "experience level" : agencyOperatorEval ? "primary agency operator" : "role"} before continuing`,
        };
      }
      return { isDisabled: false, reason: "" };
    case 1:
      if (info.storeType === "development" && !info.productionStoreUrl) {
        return {
          isDisabled: true,
          reason: "Please fill out your production store URL before continuing",
        };
      }
      return { isDisabled: false, reason: "" };
    case 2:
      if (info.goals.includes("Set a Custom Goal") && !info.otherGoal) {
        return {
          isDisabled: true,
          reason: "Please fill out your goal before continuing",
        };
      }
      if (info.goals.length === 0) {
        return {
          isDisabled: true,
          reason: "Please select at least one goal before continuing",
        };
      }
      return { isDisabled: false, reason: "" };
    case 3:
      if (
        booleanEval(info.buyingIntention) ||
        (info.buyingIntention === "Other" && !info.otherBuyingIntention)
      ) {
        return {
          isDisabled: true,
          reason:
            "Please fill out what prompted you to try Intelligems before continuing",
        };
      }
      if (
        booleanEval(info.sourceAttribution) ||
        (info.sourceAttribution === "Other" && !info.otherSourceAttribution)
      ) {
        return {
          isDisabled: true,
          reason:
            "Please fill out where you heard about Intelligems before continuing",
        };
      }
      return { isDisabled: false, reason: "" };
    default:
      return { isDisabled: false, reason: "" };
  }
};

export const getMixpanelStepTitle = (step: number) => {
  switch (step) {
    case 0:
      return "User Information";
    case 1:
      return "Store Information";
    case 2:
      return "Goals Information";
    case 3:
      return "Sales Information";
    case 4:
      return "Billing Information";
    default:
      return "Default Step Return";
  }
};

export const getMixpanelStepData = (data: OnboardingInfoFe, step: number) => {
  switch (step) {
    case 0:
      return {
        preferred_name: data.preferredName,
        preferred_email: data.preferredEmail,
        company_role:
          data.companyRole === "Other" ? data.otherRole : data.companyRole,
        team_description: data.teamDescription,
        ...(data.companyRole === "Agency User" && {
          agency_primary_operator: data.agencyPrimaryOperator,
        }),
        previous_experience: data.previousExperience,
      };
    case 1:
      return {
        store_type: data.storeType,
        user_reported_order_count: data.userReportedOrderCount,
        production_store_url: data.productionStoreUrl,
      };
    case 2:
      return {
        goals:
          data.goals.includes("Set a Custom Goal") && data.otherGoal
            ? data.otherGoal
            : data.goals,
      };
    case 3:
      return {};
    case 4:
      return {
        suggested_plan: data.recommendedPlan,
      };
    default:
      return {};
  }
};
